export const strokePlayWebsockets = {
  leaderboard: 'Leaderboard',
  rounddetails: 'Round Details',
  holestats: 'Hole Stats',
  playerstats: 'Player Stats',
  playerrankstats: 'Player Stats Ranking',
  teamsstats: 'Teams Stats'
} as const

export const matchPlayWebsockets = {
  matchplayleaderboard: 'Match Play Leaderboard',
  matchdetails: 'Match Details',
  matchscore: 'Match Score'
} as const
